export default "__VITE_ASSET__0e1d0a91__"